/**
 * OrbitalLoader — shared loader visual used by onboarding/Computing AND by
 * the avatar-flow generation screen. Single source of truth for the
 * "rings + breathing sigil" loader pattern.
 *
 * Combines <OrbitalRings /> (dotted contra-rotating rings) with
 * <LivingSigil state="breathing" /> centered inside, behind a soft gold glow.
 */
import { OrbitalRings } from './OrbitalRings.js';
import { LivingSigil } from './LivingSigil.js';
import styles from './OrbitalLoader.module.css';

export interface OrbitalLoaderProps {
  /** Sigil size in px. Default 160. */
  sigilSize?: number;
}

export function OrbitalLoader({ sigilSize = 160 }: OrbitalLoaderProps): JSX.Element {
  return (
    <div className={styles.orbitContainer} aria-hidden="true">
      <OrbitalRings />
      <div className={`${styles.sigilWrapper} ${styles.sigilGlow}`}>
        <LivingSigil size={sigilSize} state="breathing" />
      </div>
    </div>
  );
}

export default OrbitalLoader;
